import styled from 'styled-components';

export const ArtistCoverContainer = styled.div`
    background-color:black;
    display:flex;
    width:100vw;
    height:20vw;
    align-items:center;
`

export const ArtistCoverImageContainer = styled.img`
    width:25vw;
    height:20vw;
`

export const TextContainer = styled.div`
    flex-direction: column;
    color:white;
    font-size:2em;
    margin-left:20px;
`